<template>
    <v-card>
        <v-card-title>
            <h1>{{  title }}</h1>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :pagination.sync="pagination" :total-items="pagination.totalItems" hide-actions>
            <v-progress-linear v-if="loading" slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td v-for="h in headers" :class="{'hide-column' : h.class == 'hide-column', 'text-xs-center' : h.align == 'center', 'text-xs-left' : h.align == 'left', 'text-xs-right' : h.align == 'right'}">
                    <span v-if="h.href">
                        <v-btn :color="h.text == 'View' ? 'primary' : ''" v-if="$vuetify.breakpoint.xsOnly && h.text == 'View'" fab small @click="goto(getLink(props.item, h))"><v-icon>fa-eye</v-icon></v-btn>
                        <v-btn :color="h.text == 'View' ? 'primary' : ''" v-else :href="getLink(props.item, h)">{{ h.text }}</v-btn>
                    </span>
                    <span v-else-if="h.value == 'created_at'">
                        {{ formatDate(findCelData(props.item, h.value)) }}
                    </span>
                    <span v-else-if="h.value == 'name'">
                        {{ findCelData(props.item, h.value) }}<v-icon right small :color="getAdminColor(props.item.role_id)">{{ getAdminIcon(props.item.role_id) }}</v-icon>
                    </span>
                    <span v-else>
                        {{ findCelData(props.item, h.value) }}
                    </span>
                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="pages > 1">
          <v-pagination v-model="current_page" :length="pages"></v-pagination>
        </div>
    </v-card>
</template>

<script>

    const request = require('superagent');
    const debounce = require('debounce');
    import DataGrid from './DataGrid.vue';

    export default {
        extends: DataGrid,
        props : ['url', 'title'],
        data : function(){
            return {

            }
        },
        mounted() {

        },
        computed : {

        },
        methods : {
            getAdminIcon : function(role_id){
                if(role_id ==1){
                    return 'fa-user-shield';
                }
                if(role_id == 3 || role_id == 4){
                    return 'fa-user-tie';
                }
                return '';
            },
            getAdminColor : function(role_id){
                if(role_id ==1){
                    return 'blue';
                }
                if(role_id ==3){
                    return 'green';
                }
                if(role_id ==4){
                    return 'red';
                }
                return '';
            },
            goto : function(dest){
                document.location = dest;
            }
        },
        watch : {

        }
    }
</script>
